import {
  GetCorpContactCardContainerDocument,
  GetCorpContactCardContainerQuery,
  GetCorpContactCardContainerQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getCorpContactCardContainer(id: string, locale: string) {
  return client.query<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>({
    query: GetCorpContactCardContainerDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
